var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneFilled = function SvgPhoneFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.056 21.88a20.04 20.04 0 0 1-8.718-5.128A20.04 20.04 0 0 1 2.21 8.034l-.016-.056c-.148-.519-.262-.921-.264-1.473a4.4 4.4 0 0 1 .513-1.971c.531-.946 1.672-2.158 2.657-2.656a3 3 0 0 1 2.708 0c.842.426 1.78 1.38 2.303 2.183a3 3 0 0 1 0 3.271c-.173.266-.42.513-.706.8-.09.088-.188.153-.123.289a13.6 13.6 0 0 0 2.652 3.735 13.6 13.6 0 0 0 3.736 2.652c.14.068.196-.029.29-.122.285-.287.532-.534.798-.707a3 3 0 0 1 3.27 0c.784.509 1.762 1.468 2.185 2.303a3 3 0 0 1 0 2.708c-.499.986-1.71 2.126-2.657 2.658-.55.308-1.34.514-1.97.512-.552-.002-.955-.116-1.474-.263z",
    clipRule: "evenodd"
  })));
};
export default SvgPhoneFilled;